import * as L from "leaflet";

const MODE_PILOT_UI_FLIGHT_MARKER_LABELS_TOGGLED =
  "MODE_PILOT_UI_FLIGHT_MARKER_LABELS_TOGGLED";

export const MODE_PILOT_UI_SIDEBAR_VISIBILITY_TOGGLED =
  "MODE_PILOT_UI_SIDEBAR_VISIBILITY_TOGGLED";

export const MODE_PILOT_UI_ACTIVE_NAIL_SELECTED =
  "MODE_PILOT_UI_ACTIVE_NAIL_SELECTED";

export interface IModePilotUi {
  showFlightMarkerLabelsIsOn: boolean;
  sidebarIsVisible: boolean;
  activeNailId: string;
}

const defaultState: IModePilotUi = {
  showFlightMarkerLabelsIsOn: false,
  sidebarIsVisible: L.Browser.mobile === false,
  activeNailId: null,
};

export const togglePilotFlightMarkerLabels = (): IAction<void> => ({
  type: MODE_PILOT_UI_FLIGHT_MARKER_LABELS_TOGGLED,
  payload: null,
});

export const toggleSidebarVisibility = (): IAction<void> => ({
  payload: null,
  type: MODE_PILOT_UI_SIDEBAR_VISIBILITY_TOGGLED,
});

export const selectActiveNail = (nailId: string): IAction<string> => ({
  payload: nailId,
  type: MODE_PILOT_UI_ACTIVE_NAIL_SELECTED,
});

export default function reducer(
  state: IModePilotUi = defaultState,
  action: IAction<any>,
): IModePilotUi {
  switch (action.type) {
    case MODE_PILOT_UI_FLIGHT_MARKER_LABELS_TOGGLED:
      return {
        ...state,
        showFlightMarkerLabelsIsOn: !state.showFlightMarkerLabelsIsOn,
      };
    case MODE_PILOT_UI_SIDEBAR_VISIBILITY_TOGGLED:
      return {
        ...state,
        sidebarIsVisible: !state.sidebarIsVisible,
      };
    case MODE_PILOT_UI_ACTIVE_NAIL_SELECTED:
      return {
        ...state,
        activeNailId: action.payload,
      };
    default:
      return state;
  }
}
